import type { EffectParams } from '@swf/core/store';

const acceptSotdTerms = async (version: number, { dispatch, request }: EffectParams) => {
  try {
    await request({ service: 'casino.prizegame.acceptTerms', body: { version } });
    dispatch.modal.close('/casino/help');
    dispatch.casino.set({ sotdTermsVersionAccepted: version });
  } catch {
    dispatch.modal.close('/casino/help');
  }
};

export default acceptSotdTerms;
